import React from 'react';
import { validations } from './validations';
import NodeWrapper from './NodeWrapper';
import ControllerExternalFunction from './themes/classic/ControllerDelegate';

const ControllerDelegate = (props) => {
  const iconStyle = {
    left: '36%',
    top: '1%',
    width: '49px',
    height: '46px'
  };

  return (
    <>
      <NodeWrapper {...props}>
        <ControllerExternalFunction props={props} validations={validations} iconStyle={iconStyle} />

        {/* <div className='external-delegate'>
          <Grid container spacing={2}>
            
            <Icon icon={'admin_controller'} />            
          </Grid>
        </div>

        <Handle type="source" className={'external-delegate-handle'} node="external_function" position="bottom" isValidConnection={validations('source', 'external_function')} id="bottom1" />

        <Grid item xs={12}><p style={titleSyle}>{props.data.label}</p></Grid> */}

      </NodeWrapper>
    </>
  );
};

export default ControllerDelegate;
